import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import AutoSuggest from '../../input-fields/auto-suggest';

export const AutoSuggestFormField = forwardRef(
  ({ label, options, name, ...rest }, ref) => {
    const [items, setItems] = useState([]);
    const { setFieldValue } = useFormikContext();

    const optionLabels = options?.map((option) => option.label);

    const onInputValueChange = ({ inputValue }) => {
      setFieldValue(name, inputValue);

      if (inputValue.length > 0) {
        setItems(
          optionLabels.filter((optionLabel) =>
            optionLabel.toLowerCase().includes(inputValue.toLowerCase())
          )
        );
      } else {
        setItems([]);
      }
    };

    return (
      <AutoSuggest
        ref={ref}
        name={name}
        labelText={label}
        items={items}
        onInputValueChange={onInputValueChange}
        showSearchIcon={false}
        {...rest}
      />
    );
  }
);

AutoSuggestFormField.displayName = 'AutoSuggestFormField';

AutoSuggestFormField.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
  name: PropTypes.string,
};

export default AutoSuggestFormField;
